import { render, staticRenderFns } from "./LexinDictionary.vue?vue&type=template&id=e41e20ec&"
import script from "./LexinDictionary.vue?vue&type=script&lang=js&"
export * from "./LexinDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports